import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoOdontologia from "./CreaEquipos/CreaEquipoOdontologia";
import Cookies from "universal-cookie";
import DequipoOdontologia from "../../EliminaEquipos/DequipoOdontologia";

function EquipoOdontologia({ idSolicitud }) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  // 🔹 Obtener datos
  const obtenerDatos = async () => {
    try {
      const response = await axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoOdontologiaGeneralPorSolicitudId?SolicitudId=${idSolicitud}`,
      });

      setList(response.data || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (idSolicitud) {
      obtenerDatos();
    }
  }, [idSolicitud]);

  // 🔹 Eliminar sin recargar
  const handleDelete = (id) => {
    setList((prev) => prev.filter((item) => item.id !== id));
  };

  const nombreRuta =
    window.location.href.split("/")[
      window.location.href.split("/").indexOf("#") + 1
    ];

  return (
    <div className="container">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="m-0 font-weight-bold text-primary">
            4.2. Equipo Primario de Mejoramiento de Odontología General
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoOdontologia
                idSolicitud={idSolicitud}
                onSuccess={obtenerDatos}
              />
            )}

          <div className="table-responsive mt-3">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Servicio</th>
                  <th>Cargo</th>
                  <th>Líder</th>
                  {nombreRuta === "ProcesoAutoevaluacion" && <th>Eliminar</th>}
                </tr>
              </thead>

              <tbody>
                {list.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No hay registros
                    </td>
                  </tr>
                ) : (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre}</td>
                      <td>{item.servicio}</td>
                      <td>{item.cargo}</td>
                      <td>{item.lider}</td>

                      {nombreRuta === "ProcesoAutoevaluacion" && (
                        <td>
                          <DequipoOdontologia
                            id={item.id}
                            onDelete={handleDelete}
                          />
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EquipoOdontologia;
